'use client';

import {SuccessScreenContentType} from '@dev-landing/forms/Forms.entity';
import {SupportModal} from '@shared/SupportModal/SupportModal';
import {
  DEVELOPER_API_FILE_UPLOAD_URL,
  DEVELOPER_API_SUBMIT_URL,
} from '@strapi/consts';
import {useCallback, useState} from 'react';

import {WriteSupportForm} from '@dev-landing/strapi/types';

import styles from './SupportButton.module.scss';

type Props = {
  buttonText: string;
  successScreenContent: SuccessScreenContentType;
  writeSupportForm: WriteSupportForm;
};

export const SupportButton = ({
  buttonText,
  successScreenContent,
  writeSupportForm,
}: Props) => {
  const [modalShown, setModalShown] = useState(false);

  const setShowModal = useCallback(
    () => setModalShown(!modalShown),
    [modalShown],
  );

  return (
    <>
      {modalShown && (
        <SupportModal
          successScreenContent={successScreenContent}
          setShowModal={setShowModal}
          writeSupportForm={writeSupportForm}
          submitApiUrl={DEVELOPER_API_SUBMIT_URL}
          fileUploadApiUrl={DEVELOPER_API_FILE_UPLOAD_URL}
        />
      )}
      <button
        className={styles.button}
        onClick={setShowModal}
        data-testid={'support_button_id'}
      >
        {buttonText}
      </button>
    </>
  );
};
